import Vue from 'vue'
// import {any} from '@/bin/global.extend'
//首页

let rpaComponents: any = [];

export default rpaComponents;

rpaComponents.push({
	name: '魔音工坊',
	path: '/',
	redirect: '/article'
})
rpaComponents.push({
	component: Vue.component('indexPage', (resolve) => require(['@/views/index/index.vue'], resolve)),
	name: "魔音工坊",
	path: "/article",
	meta: {
		title: '魔音工坊'
	}
});

rpaComponents.push({
	component: Vue.component('testPage', (resolve) => require(['@/views/test/test.vue'], resolve)),
	name: "test",
	path: "/test",
	meta: {}
});
rpaComponents.push({
	component: Vue.component('testPage', (resolve) => require(['@/views/test/test2.vue'], resolve)),
	name: "test2",
	path: "/test2",
	meta: {}
});
rpaComponents.push({
	component: Vue.component('testPage', (resolve) => require(['@/views/test/test3.vue'], resolve)),
	name: "test3",
	path: "/test3",
	meta: {}
});
rpaComponents.push({
	component: Vue.component('extractResultPage', (resolve) => require(['@/views/extractResult/extractResult.vue'], resolve)),
	name: "extractResultPage",
	path: "/extractResult",
	mate: {}
});
rpaComponents.push({
	component: Vue.component('CourseDetailPage', (resolve) => require(['@/views/CourseDetail/CourseDetail.vue'], resolve)),
	name: "CourseDetailPage",
	path: "/CourseDetail",
	mate: {}
});
rpaComponents.push({
	component: Vue.component('CourseRulePage', (resolve) => require(['@/views/CourseRule/CourseRule.vue'], resolve)),
	name: "CourseRulePage",
	path: "/CourseRule",
	mate: {}
});
rpaComponents.push({
	component: Vue.component('magicPage', (resolve) => require(['@/views/magic/magic.vue'], resolve)),
	name: "magicPage",
	path: "/magic",
	mate: {}
});
rpaComponents.push({
	component: Vue.component('magicServicePage', (resolve) => require(['@/views/magicService/magicService.vue'], resolve)),
	name: "magicServicePage",
	path: "/magicService",
	mate: {}
});
rpaComponents.push({
	component: Vue.component('magicPaysPage', (resolve) => require(['@/views/magicPays/magicPays.vue'], resolve)),
	name: "magicPaysPage",
	path: "/magicPays",
	meta: {}
});
// 会员分销 h5 支付
rpaComponents.push({
	component: Vue.component('vipWechatPay', (resolve) => require(['@/views/VipWechatPay/index.vue'], resolve)),
	name: "魔 音 工 坊",
	path: "/vipWechatPay1",
	meta: {}
})

// 会员分销支付成功
rpaComponents.push({
	component: Vue.component('paySuccess', (resolve) => require(['@/views/VipWechatPay/success.vue'], resolve)),
	name: "魔音工坊",
	path: "/paySuccess",
	meta: {}
})
// 元创岛会员分销支付成功
rpaComponents.push({
	component: Vue.component('ycdPaySuccess', (resolve) => require(['@/views/VipWechatPay/success-ycd.vue'], resolve)),
	name: "元创岛",
	path: "/ycdPaySuccess",
	meta: {}
})

		rpaComponents.push({
			component: Vue.component('voiceShopPage',(resolve) => require(['@/views/voiceShop/voiceShop.vue'], resolve)),
			name:"声音商店",
			path:"/voiceShop",
			mate:{}
		});
	
		rpaComponents.push({
			component: Vue.component('voiceAllPage',(resolve) => require(['@/views/voiceAll/voiceAll.vue'], resolve)),
			name:"魔音工坊",
			path:"/vipWechatPay",
			mate:{}
		});
    	rpaComponents.push({
			component: Vue.component('downloadAppPage',(resolve) => require(['@/views/downloadApp/downloadApp.vue'], resolve)),
			name:"downloadApp",
			path:"/downloadApp",
			mate:{}
		});

		rpaComponents.push({
			component: Vue.component('realPersonVoiceoverPayPage',(resolve) => require(['@/views/realPersonVoiceoverPay/realVoicePay.vue'], resolve)),
			name:"真人配音",
			path:"/realPersonVoiceoverPay",
			mate:{}
		});
	
		rpaComponents.push({
			component: Vue.component('realVoicePayPage',(resolve) => require(['@/views/realVoicePay/realVoicePay.vue'], resolve)),
			name:"真人配音",
			path:"/realVoicePay",
			mate:{}
		});
		rpaComponents.push({
			component: Vue.component('protocolPage',(resolve) => require(['@/components/protocol/protocol-detail.vue'], resolve)),
			name:"protocolPage",
			path:"/protocol",
			mate:{}
		});
	
		rpaComponents.push({
			component: Vue.component('privacyPage',(resolve) => require(['@/components/protocol/privacy-policy.vue'], resolve)),
			name:"privacyPage",
			path:"/privacy",
			mate:{}
		});
	
		rpaComponents.push({
			component: Vue.component('commonListPage',(resolve) => require(['@/components/protocol/protocol-common.vue'], resolve)),
			name:"commonListPage",
			path:"/commonList",
			mate:{}
		});
		rpaComponents.push({
			component: Vue.component('sdkPage',(resolve) => require(['@/components/protocol/protocol-sdk.vue'], resolve)),
			name:"sdkPage",
			path:"/sdkList",
			mate:{}
		});
        ///videoProtocol
        rpaComponents.push({
			component: Vue.component('videoProtocolPage',(resolve) => require(['@/components/protocol/video-protocol.vue'], resolve)),
			name:"videoProtocolPage",
			path:"/videoProtocol",
			mate:{}
		});
		rpaComponents.push({
			component: Vue.component('payMiddlePagePage',(resolve) => require(['@/views/payMiddlePage/payMiddlePage.vue'], resolve)),
			name:"payMiddlePagePage",
			path:"/middlePageOfPay",
			mate:{}
		});
		rpaComponents.push({
			component: Vue.component('realPersonPaySuccess',(resolve) => require(['@/views/realPersonVoiceoverPay/realPaySuccess.vue'], resolve)),
			name:"realPersonPaySuccess",
			path:"/realPersonPaySuccess",
			mate:{}
		});
		rpaComponents.push({
			component: Vue.component('realPaySuccess',(resolve) => require(['@/views/realVoicePay/realPaySuccess.vue'], resolve)),
			name:"realPaySuccess",
			path:"/realPaySuccess",
			mate:{}
		});
		rpaComponents.push({
			component: Vue.component('voiceClone',(resolve) => require(['@/views/voiceClone/voiceClone.vue'], resolve)),
			name:"voiceClone",
			path:"/voiceClone",
			mate:{}
		});
		rpaComponents.push({
			component: Vue.component('voicePaySuccess', (resolve) => require(['@/views/voiceClone/success.vue'], resolve)),
			name: "魔音工坊",
			path: "/voicePaySuccess",
			meta: {}
		})
		rpaComponents.push({
			component: Vue.component('realVoiceCustomerPage',(resolve) => require(['@/views/realVoiceCustomer/realVoiceCustomer.vue'], resolve)),
			name:"真人配音添加客服",
			path:"/realVoiceCustomer",
			mate:{}
		});
	
		rpaComponents.push({
			component: Vue.component('realFreeAuditionPage',(resolve) => require(['@/views/realFreeAudition/realFreeAudition.vue'], resolve)),
			name:"真人配音网-魔音工坊",
			path:"/realFreeAudition",
			mate:{}
		});
	rpaComponents.push({
		component: Vue.component('extraListPage',(resolve) => require(['@/views/extraList/extraList.vue'], resolve)),
		name:"extraListPage",
		path:"/extraList",
		mate:{}
	});
	rpaComponents.push({
		component: Vue.component('fileExtractPage',(resolve) => require(['@/views/fileExtract/fileExtract.vue'], resolve)),
		name:"fileExtractPage",
		path:"/fileExtract",
		meta:{}
	});
	
		rpaComponents.push({
			component: Vue.component('withDrawalIndexPage',(resolve) => require(['@/views/withDrawalIndex/withDrawalIndex.vue'], resolve)),
			name:"withDrawalIndexPage",
			path:"/withDrawalIndex",
			mate:{}
		});
	
		rpaComponents.push({
			component: Vue.component('withDrawalListPage',(resolve) => require(['@/views/withDrawalList/withDrawalList.vue'], resolve)),
			name:"withDrawalListPage",
			path:"/withDrawalList",
			mate:{}
		});
	
		rpaComponents.push({
			component: Vue.component('bankCardListPage',(resolve) => require(['@/views/bankCardList/bankCardList.vue'], resolve)),
			name:"bankCardListPage",
			path:"/bankCardList",
			mate:{}
		});
		rpaComponents.push({
			component: Vue.component('AccreditPage',(resolve) => require(['@/views/accredit/accredit.vue'], resolve)),
			name:"accreditPage",
			path:"/accredit",
			mate:{}
		});
		rpaComponents.push({
			component: Vue.component('ActivityPage',(resolve) => require(['@/views/activity/activity.vue'], resolve)),
			name:"activityPage",
			path:"/activity",
			mate:{}
		});
		rpaComponents.push({
			component: Vue.component('LeaderboardPage',(resolve) => require(['@/views/leaderboard/leaderboard.vue'], resolve)),
			name:"leaderboardPage",
			path:"/leaderboard",
			mate:{}
		});
		rpaComponents.push({
			component: Vue.component('ActivityManagerPage',(resolve) => require(['@/views/activityManager/activityManager.vue'], resolve)),
			name:"activityManagerPage",
			path:"/activityManager",
			mate:{}
		});
		rpaComponents.push({
			component: Vue.component('textGeneratePage',(resolve) => require(['@/views/textGenerate/textGenerate.vue'], resolve)),
				name:"textGeneratePage",
				path:"/textGenerate",
				mate:{}
		});
		rpaComponents.push({
			component: Vue.component('textGenerateListPage',(resolve) => require(['@/views/textGenerateList/textGenerateList.vue'], resolve)),
			name:"textGenerateListPage",
			path:"/textGenerateList",
			mate:{}
		});

		rpaComponents.push({
			component: Vue.component('welfareCenterPage',(resolve) => require(['@/views/welfareCenter/welfareCenter.vue'], resolve)),
			name:"福利中心",
			path:"/welfareCenter",
			mate:{}
		});

	
		rpaComponents.push({
			component: Vue.component('memberDayPage',(resolve) => require(['@/views/memberDay/memberDay.vue'], resolve)),
			name:"会员日",
			path:"/memberDay",
			mate:{}
		});

		rpaComponents.push({
			component: Vue.component('signInPage',(resolve) => require(['@/views/signIn/signIn.vue'], resolve)),
			name:"每日签到",
			path:"/signIn",
			mate:{}
		});

		rpaComponents.push({
			component: Vue.component('exchangeBeanPage',(resolve) => require(['@/views/exchangeBean/exchangeBean.vue'], resolve)),
			name:"魔豆兑换",
			path:"/exchangeBean",
			meta:{}
		});

		rpaComponents.push({
			component: Vue.component('chargeBeanPage',(resolve) => require(['@/views/chargeBean/chargeBean.vue'], resolve)),
			name:"累充福利",
			path:"/chargeBean",
			meta:{}
		});
	
		rpaComponents.push({
			component: Vue.component('welfareRulesPage',(resolve) => require(['@/views/welfareRules/welfareRules.vue'], resolve)),
			name:"活动规则",
			path:"/welfareRules",
			mate:{}
		});
	
		rpaComponents.push({
			component: Vue.component('welfareRecordsPage',(resolve) => require(['@/views/welfareRecords/welfareRecords.vue'], resolve)),
			name:"获得/兑换记录",
			path:"/welfareRecords",
			mate:{}
		});

// rpaComponents.push({
// 	component: Vue.component('order', (resolve) => require(['@/views/order/keep.vue'], resolve)),
// 	name: "order",
// 	path: "/order",
// 	mate: {
// 		keepAlive: true
// 	},
// 	redirect: '',
// 	children:[
// 		{
// 			component: Vue.component('order', (resolve) => require(['@/views/order/index.vue'], resolve)),
// 			name: "order",
// 			path: "",
// 			mate: {
// 				keepAlive: true
// 			},
// 		},
// 		{
// 			component: Vue.component('invoicing', (resolve) => require(['@/views/order/invoicing.vue'], resolve)),
// 			name: "invoicing",
// 			path: "/order/invoicing",
// 			mate: {
// 				keepAlive: true
// 			},
// 		}
// 	]
// });

rpaComponents.push({
	component: Vue.component('order', (resolve) => require(['@/views/order/index.vue'], resolve)),
	name: "order",
	path: "/order",
	meta: {
		title: '消费记录'
	}
});

rpaComponents.push({
	component: Vue.component('invoicing', (resolve) => require(['@/views/order/invoicing.vue'], resolve)),
	name: "invoicing",
	path: "/order/invoicing",
	meta: {
		title: '开具发票'
	}
});

rpaComponents.push({
	component: Vue.component('invoicHistory', (resolve) => require(['@/views/order/history.vue'], resolve)),
	name: "invoicHistory",
	path: "/order/invoicHistory",
	meta: {
		title: '开票历史'
	}
});

rpaComponents.push({
	component: Vue.component('invoicDetail', (resolve) => require(['@/views/order/detail.vue'], resolve)),
	name: "invoicDetail",
	path: "/order/invoicDetail",
	meta: {
		title: '发票详情'
	}
});

rpaComponents.push({
	component: Vue.component('invoicDetail2', (resolve) => require(['@/views/order/detail2.vue'], resolve)),
	name: "invoicDetail2",
	path: "/order/invoicDetail2",
	meta: {
		title: '发票详情'
	}
});

rpaComponents.push({
	component: Vue.component('invoicDetail3', (resolve) => require(['@/views/order/detail3.vue'], resolve)),
	name: "invoicDetail2",
	path: "/order/invoicDetail3",
	meta: {
		title: '发票预览'
	}
});

rpaComponents.push({
	component: Vue.component('invoicReissue', (resolve) => require(['@/views/order/reissue.vue'], resolve)),
	name: "invoicReissue",
	path: "/order/invoicReissue",
	meta: {
		title: '重发发票'
	}
});

rpaComponents.push({
	component: Vue.component('success', (resolve) => require(['@/views/order/success.vue'], resolve)),
	name: "success",
	path: "/order/success",
	meta: {
		title: '开具发票'
	}
});

	
rpaComponents.push({
	component: Vue.component('sameStylePage',(resolve) => require(['@/views/sameStyle/sameStyle.vue'], resolve)),
	name:"sameStylePage",
	path:"/sameStyle",
	mate:{}
});

rpaComponents.push({
	component: Vue.component('cutDetail',(resolve) => require(['@/views/cutDetail/index.vue'], resolve)),
	name:"模版详情",
	path:"/cutDetail",
  meta: {}
})
	
rpaComponents.push({
  component: Vue.component('videoWechatPayPage',(resolve) => require(['@/views/videoWechatPay/videoWechatPay.vue'], resolve)),
  name:"videoWechatPayPage",
  path:"/videoWechatPay/:packageId",
  mate:{}
});
	
rpaComponents.push({
	component: Vue.component('videoPaySuccessPage',(resolve) => require(['@/views/videoPaySuccess/videoPaySuccess.vue'], resolve)),
	name:"videoPaySuccessPage",
	path:"/videoPaySuccess",
	mate:{}
});

// 元创岛会员分销 h5 支付
rpaComponents.push({
	component: Vue.component('ycdChannel', (resolve) => require(['@/views/VipWechatPay/ycd-channel-index.vue'], resolve)),
	name: "元 创 岛",
	path: "/ycd-channel",
	meta: {}
})

// 元创岛会员 h5 购买页
rpaComponents.push({
	component: Vue.component('ycdVip', (resolve) => require(['@/views/VipWechatPay/ycd-payment-index.vue'], resolve)),
	name: "元创岛",
	path: "/ycd-vip",
	meta: {}
})

// 元创岛会员 h5 购买支付中间页
rpaComponents.push({
	component: Vue.component('ycdVipMiddle', (resolve) => require(['@/views/VipWechatPay/ycd-payment-middle.vue'], resolve)),
	name: "元创岛",
	path: "/ycd-payment-middle",
	meta: {}
})

// 元创岛会员 h5 购买支付成功页面
rpaComponents.push({
	component: Vue.component('ycdVipSuccess', (resolve) => require(['@/views/VipWechatPay/ycd-payment-success.vue'], resolve)),
	name: "元创岛",
	path: "/ycd-payment-success",
	meta: {}
})
rpaComponents.push({
    component: Vue.component('couponListPage',(resolve) => require(['@/views/couponList/couponList.vue'], resolve)),
    name:"couponListPage",
    path:"/couponList",
    mate:{}
});
rpaComponents.push({
    component: Vue.component('autoRePayPage',(resolve) => require(['@/components/protocol/auto-repay.vue'], resolve)),
    name:"autoRePayPage",
    path:"/autoRePay",
    mate:{}
});

rpaComponents.push({
	component: Vue.component('subscription',(resolve) => require(['@/views/subscription/index.vue'], resolve)),
	name:"连续订阅",
	path:"/subscription",
  meta: {}
})

	
		rpaComponents.push({
			component: Vue.component('moyouPicPage',(resolve) => require(['@/views/moyouPic/moyouPic.vue'], resolve)),
			name:"moyouPicPage",
			path:"/moyouPic",
			mate:{}
		});
rpaComponents.push({
	component: Vue.component('indexPage', (resolve) => require(['@/views/recall/index.vue'], resolve)),
	name: "魔音工坊",
	path: "/recall",
	meta: {}
})